const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'gmx.com',
  'zoho.com',
  'yandex.com',
  'mail.com',
  'mail.ru',
  'rediffmail.com',
  'qq.com',
  '163.com',
  'naver.com',
]);

export const WORK_EMAIL_POLICY_TEXT =
  "Please sign up with your work or company email address. Personal email providers such as Gmail, Yahoo, and Outlook aren't supported.";

export const isPersonalEmailDomain = (email: string): boolean => {
  const domain = email.trim().split('@')[1]?.toLowerCase();
  return Boolean(domain && PERSONAL_EMAIL_DOMAINS.has(domain));
};
